module.exports = __webpack_public_path__ + "feature-highlight-1-1x-8d609ea7b254e455a9e06151f5fe8578.webp";